<ng-template cdkConnectedOverlay
             [cdkConnectedOverlayHasBackdrop]="false"
             [cdkConnectedOverlayOpen]="open()"
             [cdkConnectedOverlayOrigin]="origin"
             (backdropClick)="open.set(false)"
             (detach)="open.set(false)">
  <bspk-scrim owner="dialog" (click)="open.set(false)" />
  <div cdkTrapFocus
       data-bspk="dialog"
       role="presentation"
       [attr.data-placement]="placement()">
    <div data-dialog-box
        tabIndex="-1"
        [attr.data-width-full]="widthFull()"
        [style.width]="width()">
      <ng-content/>
    </div>
  </div>
</ng-template>
